<template>
    <div>
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.kuli }}</h3>
            <Tag color="success">币别</Tag>
            <currency v-model="itemData.currency"></currency>
        </div>
        <div style="display: flex">
            <Tag color="blue">起步价：</Tag>
            <InputNumber v-model="itemData.startPirce"></InputNumber>
            <Tag color="blue">起步价(进口)</Tag>
            <InputNumber size="small" v-model="itemData.startPirceIn"></InputNumber>
        </div>
        <div id="itemList" v-for="(item, row) in itemData.list" :key="row">
            <div class="fenleibiaoti">
                <unitBox :unit="item.unit" :units="kulis[row]" @on-change="unitChange(item, $event)">
                </unitBox>

            </div>
            <div class="priceTable">
                <div>
                    <p>
                        <moreLine :readonly="true" v-model="item.unit"> </moreLine>
                    </p>
                    <p>
                        <Input readonly :border="false" size="small" v-model="item.name"></Input>
                    </p>
                </div>
                <div v-for="(x, col) in item.list" :key="col">
                    <p>
                        <moreLine v-model="x.unit"> </moreLine>
                    </p>
                    <p>
                        <Input :border="false" size="small" v-model="x.price"></Input>
                    </p>
                    <div style="margin-top: 4px;" v-show="isUpdate">
                        <Button title="新增列" icon="md-add" size="small" type="success"
                            @click="addCol(col, item.list)"></Button>
                        <Button title="删除列" icon="md-close" size="small" type="success"
                            @click="delCol(col, item.list)"></Button>
                        <Button title="往前移" icon="md-arrow-round-back" size="small" type="primary"
                            @click="prevCol(col, item.list)"></Button>
                        <Button title="往后移" icon="md-arrow-forward" size="small" type="primary"
                            @click="nextCol(col, item.list)"></Button>

                    </div>
                </div>
            </div>
        </div>

        <div>
            <Tag color="success"> 超重计费 </Tag>
            <RadioGroup v-model="itemData.formula">
                <Radio :label="1">
                    <span>每件(板)超出1kg加收</span>
                    <InputNumber style="width: 100px" size="small" v-model="itemData.outRange.kgsCz1"></InputNumber>               
                </Radio>
                <Radio :label="3">
                    <span>总体积超出1cbm加收</span>
                    <InputNumber style="width: 100px" size="small" v-model="itemData.outRange.cbmCz3"></InputNumber>
                </Radio>
                <Radio :label="2">
                    超出区间外，取最大（<InputNumber style="width: 100px" v-model="itemData.outRange.kgsCz2" size="small">
                    </InputNumber>/kg或<InputNumber style="width: 100px" size="small" v-model="itemData.outRange.cbmCz2">
                    </InputNumber>/cbm）</Radio>
            </RadioGroup>
        </div>
        <div style="margin-bottom: 20px">
            <Tag color="error">单价计费</Tag>
            <InputNumber style="width: 100px" size="small" v-model="itemData.partPrice.kgs"></InputNumber><span
                style="margin-right: 20px">元/kg </span>
            <InputNumber style="width: 100px" size="small" v-model="itemData.partPrice.cbm"></InputNumber><span
                style="margin-right: 20px">元/cbm </span>
            <InputNumber style="width: 100px" size="small" v-model="itemData.partPrice.ctn"></InputNumber><span>元/件
            </span>
        </div>
        <div style="margin-bottom: 20px">
            <Tag color="error">散货计费</Tag>
            <InputNumber style="width: 100px" size="small" v-model="itemData.bulkPrice.kgs"></InputNumber><span
                style="margin-right: 20px">元/kg </span>
            <InputNumber style="width: 100px" size="small" v-model="itemData.bulkPrice.cbm"></InputNumber><span
                style="margin-right: 20px">元/cbm </span>
            <InputNumber style="width: 100px" size="small" v-model="itemData.bulkPrice.pl"></InputNumber>
            <span>元/板</span>
            <InputNumber style="width: 100px" size="small" v-model="itemData.bulkPrice.ctn"></InputNumber>
            <span>元/件</span>
        </div>
        <div v-if="false" style="margin-bottom: 20px">
            <Tag color="error">过板费</Tag>
            <InputNumber style="width: 100px" size="small" v-model="itemData.guobanPrice.kgs"></InputNumber><span
                style="margin-right: 20px">元/kg </span>
            <InputNumber style="width: 100px" size="small" v-model="itemData.guobanPrice.ctn"></InputNumber>
            <span>元/件</span>
        </div>
    </div>
</template>

<script>

import modelData from "../baojia/modelData";
import currency from "../baojia/currency.vue";
import unitBoxDanjia from "../baojia/unitBoxDanjia.vue";
import startAddendAdd from "../baojia/startAddendAdd.vue";
import moreLine from "../baojia/moreLine.vue";
import formula from "../baojia/formula.vue";
import unitBox from "../baojia/unitBox.vue";
export default {
    props: ["data",],
    components: { unitBox, unitBoxDanjia, startAddendAdd, currency, moreLine, formula },
    data() {
        return {
            isUpdate: true,
            zidian: modelData.zidian,
            itemData: {
                bulkPrice: {
                    "startPirce": 0,
                    "pl": 0,
                    "kgs": 0,
                    "cbm": 0,
                    "ctn": 0
                },
                guobanPrice: {
                    "startPirce": 0,
                    "pl": 0,
                    "kgs": 0,
                    "cbm": 0,
                    "ctn": 0
                },
                outRange: { kgsCz1: 0, kgsCz2: 0, cbmCz2: 0 },
                partPrice: { kgs: 0, cbm: 0, ctn: 0 },
                bulkPrice: { startPirce: 0, pl: 0, kgs: 0, cbm: 0, ctn: 0 },
                list: [],
                startPirce: 0
            },
            units: [
                {
                    name: "KGS",
                    select: true,
                },
                {
                    name: "CBM",
                    select: true,
                },
                {
                    name: "P/L",
                    select: true,
                },
            ],
            gongshi: {
                1: "danjia(0,'份','人民币')",
                2: "huoZhi(0/10000,0,'港元')",
            },
            pincheModel: modelData.pincheModel,
            kulis: [
                [
                    {
                        name: "KGS",
                        select: true,
                    },
                    {
                        name: "CBM",
                        select: true,
                    },
                ],
                [
                    {
                        name: "KGS",
                        select: true,
                    },
                    {
                        name: "CBM",
                        select: true,
                    },
                ],
            ]
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
            this.funTo();
        },
        getVal() {
            this.toFun();
            return this.itemData;
        },
        unitChange(item, abc) {
            var index = 0;
            for (let m = 0; m < item.unit.length; m++) {
                if (abc.name == item.unit[m]) {
                    index = m;
                }
            }
            var select = abc.select;
            var name = abc.name;
            var list = item.list;
            if (select) {
                //选中，添加回来
                item.unit.push(name);
                for (let i = 0; i < list.length; i++) {
                    list[i].unit.push("0-0");
                }
            } else {
                //取消选中。删除

                item.unit.splice(index, 1);
                for (let i = 0; i < list.length; i++) {
                    list[i].unit.splice(index, 1);
                }
            }
        },
        addTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            //list.splice(index, 0, obj);
            this.itemData.list.unshift(JSON.parse(JSON.stringify(obj)));
        },
        copyTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            this.itemData.list.push(JSON.parse(JSON.stringify(obj)));
        },

        //xinde
        delCol(index, list) {
            if (list.length == 1) {
                this.$Message.info('至少保留一列')
                return;
            }
            list.splice(index, 1);
        },
        addCol(index, list) {
            var m = list[index];
            list.splice(index, 0, JSON.parse(JSON.stringify(m)));

        },
        prevCol(index, list) {
            if (index == 0) {
                return;
            }
            var m = list[index];
            list.splice(index, 1);
            //setTimeout(() => {
            list.splice(index - 1, 0, m);
            //}, 5000);
        },
        nextCol(index, list) {
            if (index == list.length) {
                return;
            }
            var m = list[index];
            list.splice(index, 1);
            //setTimeout(() => {
            list.splice(index + 1, 0, m);
        },
        //转化成函数
        toFun() {
            this.itemData.function = "kuliPrice(" +
                this.itemData.startPirce + "," +
                this.itemData.startPirceIn + ")"
        },
        //函数转化为字段
        funTo() {
            eval('this.' + this.itemData.function);
        },
        kuliPrice(a, b) {
            this.itemData.startPirce = a;
            this.itemData.startPirceIn = b;
        }
    },
    mounted() {
        this.tt();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/kuli.vue